import React from "react";
import { RentReportingHomeScreenContainer } from "src/containers";

export const RentReportingHomeScreen = () => {
  return <RentReportingHomeScreenContainer />;
};
